var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __knownSymbol = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __decoratorStart = (base) => {
  var _a2;
  return [, , , __create((_a2 = base == null ? void 0 : base[__knownSymbol("metadata")]) != null ? _a2 : null)];
};
var __decoratorStrings = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError("Function expected") : fn;
var __decoratorContext = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError("Already initialized") : fns.push(__expectFn(fn || null)) });
var __decoratorMetadata = (array, target) => __defNormalProp(target, __knownSymbol("metadata"), array[3]);
var __runInitializers = (array, flags, self, value) => {
  for (var i = 0, fns = array[flags >> 1], n = fns && fns.length; i < n; i++) flags & 1 ? fns[i].call(self) : value = fns[i].call(self, value);
  return value;
};
var __decorateElement = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k = flags & 7, s = !!(flags & 8), p = !!(flags & 16);
  var j = k > 3 ? array.length + 1 : k ? s ? 1 : 2 : 0, key = __decoratorStrings[k + 5];
  var initializers = k > 3 && (array[j - 1] = []), extraInitializers = array[j] || (array[j] = []);
  var desc = k && (!p && !s && (target = target.prototype), k < 5 && (k > 3 || !p) && __getOwnPropDesc(k < 4 ? target : { get [name]() {
    return __privateGet(this, extra);
  }, set [name](x) {
    return __privateSet(this, extra, x);
  } }, name));
  k ? p && k < 4 && __name(extra, (k > 2 ? "set " : k > 1 ? "get " : "") + name) : __name(target, name);
  for (var i = decorators.length - 1; i >= 0; i--) {
    ctx = __decoratorContext(k, name, done = {}, array[3], extraInitializers);
    if (k) {
      ctx.static = s, ctx.private = p, access = ctx.access = { has: p ? (x) => __privateIn(target, x) : (x) => name in x };
      if (k ^ 3) access.get = p ? (x) => (k ^ 1 ? __privateGet : __privateMethod)(x, target, k ^ 4 ? extra : desc.get) : (x) => x[name];
      if (k > 2) access.set = p ? (x, y) => __privateSet(x, target, y, k ^ 4 ? extra : desc.set) : (x, y) => x[name] = y;
    }
    it = (0, decorators[i])(k ? k < 4 ? p ? extra : desc[key] : k > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k ^ 4 || it === void 0) __expectFn(it) && (k > 4 ? initializers.unshift(it) : k ? p ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError("Object expected");
    else __expectFn(fn = it.get) && (desc.get = fn), __expectFn(fn = it.set) && (desc.set = fn), __expectFn(fn = it.init) && initializers.unshift(fn);
  }
  return k || __decoratorMetadata(array, target), desc && __defProp(target, name, desc), p ? k ^ 4 ? extra : desc : target;
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateIn = (member, obj) => Object(obj) !== obj ? __typeError('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);

// src/horizontal-rule-extension.ts
import {
  command,
  ErrorConstant,
  extension,
  ExtensionTag,
  invariant,
  isEmptyBlockNode,
  isNodeSelection,
  NodeExtension,
  nodeInputRule
} from "@remirror/core";
import { TextSelection } from "@remirror/pm/state";

// src/horizontal-rule-utils.ts
import { ExtensionHorizontalRuleMessages as Messages } from "@remirror/messages";
var insertHorizontalRuleOptions = {
  icon: "separator",
  label: ({ t }) => t(Messages.LABEL),
  description: ({ t }) => t(Messages.DESCRIPTION)
};

// src/horizontal-rule-extension.ts
var _insertHorizontalRule_dec, _a, _HorizontalRuleExtension_decorators, _init;
_HorizontalRuleExtension_decorators = [extension({
  defaultOptions: { insertionNode: "paragraph" }
})];
var HorizontalRuleExtension = class extends (_a = NodeExtension, _insertHorizontalRule_dec = [command(insertHorizontalRuleOptions)], _a) {
  constructor() {
    super(...arguments);
    __runInitializers(_init, 5, this);
  }
  get name() {
    return "horizontalRule";
  }
  createTags() {
    return [ExtensionTag.Block];
  }
  createNodeSpec(extra, override) {
    var _a2;
    return __spreadProps(__spreadValues({}, override), {
      attrs: extra.defaults(),
      parseDOM: [{ tag: "hr", getAttrs: extra.parse }, ...(_a2 = override.parseDOM) != null ? _a2 : []],
      toDOM: (node) => ["hr", extra.dom(node)]
    });
  }
  insertHorizontalRule() {
    return (props) => {
      const { tr, dispatch } = props;
      const $pos = tr.selection.$anchor;
      const initialParent = $pos.parent;
      if (initialParent.type.name === "doc" || initialParent.isAtom || initialParent.isLeaf) {
        return false;
      }
      if (!dispatch) {
        return true;
      }
      const shouldDuplicateEmptyNode = tr.selection.empty && isEmptyBlockNode(initialParent);
      if (shouldDuplicateEmptyNode) {
        tr.insert($pos.pos + 1, initialParent);
      }
      tr.replaceSelectionWith(this.type.create());
      this.updateFromNodeSelection(tr);
      dispatch(tr.scrollIntoView());
      return true;
    };
  }
  createInputRules() {
    return [
      nodeInputRule({
        // Allow dash + hyphen to cater for ShortcutsExtension, which replaces first
        // two hyphens with a dash, i.e. "---" becomes "<dash>-"
        regexp: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type,
        beforeDispatch: ({ tr }) => {
          this.updateFromNodeSelection(tr);
        }
      })
    ];
  }
  /**
   * Updates the transaction after a `horizontalRule` has been inserted to make
   * sure the currently selected node isn't a Horizontal Rule.
   *
   * This should only be called for empty selections.
   */
  updateFromNodeSelection(tr) {
    if (!isNodeSelection(tr.selection) || tr.selection.node.type.name !== this.name) {
      return;
    }
    const pos = tr.selection.$from.pos + 1;
    const { insertionNode } = this.options;
    if (!insertionNode) {
      return;
    }
    const type = this.store.schema.nodes[insertionNode];
    invariant(type, {
      code: ErrorConstant.EXTENSION,
      message: "'".concat(insertionNode, "' node provided as the insertionNode to the '").concat(this.constructorName, "' does not exist.")
    });
    const node = type.create();
    tr.insert(pos, node);
    tr.setSelection(TextSelection.near(tr.doc.resolve(pos + 1)));
  }
};
_init = __decoratorStart(_a);
__decorateElement(_init, 1, "insertHorizontalRule", _insertHorizontalRule_dec, HorizontalRuleExtension);
HorizontalRuleExtension = __decorateElement(_init, 0, "HorizontalRuleExtension", _HorizontalRuleExtension_decorators, HorizontalRuleExtension);
__runInitializers(_init, 1, HorizontalRuleExtension);
export {
  HorizontalRuleExtension
};
